import { A, F } from '@mobily/ts-belt';
import { useEffect } from 'react';
import { Box, Grid, Placeholder, Text } from '@stitch-fix/mode-react';
import SavedItemsSubHeader from '../SavedItemsLayout/SavedItemsSubHeader';
import { TopItemsCarousel } from '../BoughtItemsLayout/TopItems/TopItemsCarousel';
const ProductCardPlaceholder = () => <Box mb={0.5} data-testid="wardrobe-items-placeholder">
    <Placeholder variant="rect" width="100%" mb={0.75} pt="125%" />
  </Box>;
const placeholders = F.toMutable(A.makeWithIndex(12, index => <ProductCardPlaceholder key={index} />));
const WardrobeItemsPlaceholder = ({
  isSavedItems
}: {
  isSavedItems?: boolean;
}) => {
  useEffect(() => {
    /**
     * We want this positioned at the top for a clean experience when removing items
     * or navigating through the wardrobe
     */
    window.scrollTo(0, 0);
  });
  return <>
      {isSavedItems ? <SavedItemsSubHeader /> : <>
          <Text mb={1} setting="title-medium" align="left">
            Top items
          </Text>
          <TopItemsCarousel loading topItems={[]} />
          <Text mb={1} setting="title-medium" align="left">
            All items
          </Text>
        </>}
      <Grid columns={{
      sm: 1,
      md: 2,
      lg: 3
    }} spacing={{
      sm: 'tight'
    }} mb={2}>
        {placeholders}
      </Grid>
    </>;
};
export default WardrobeItemsPlaceholder;